module.exports = {"id":"187858","name":"Paul-José Mpoku","rating":"74","photo":"./data/images/photos/3/187858.png","club":{"name":"Standard Liège","logo":"./data/images/clubs/StandardLiege.png"},"positions":["MG","MOC","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Paul-JoseMpoku0.json
// module id = 3388
// module chunks = 0